var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgScheduleNewActiveIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1959_124066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83331 1.16675L5.83331 3.16675M11.1666 1.16675V3.16675M11.8333 5.83342H5.16665M8.23331 15.1667H8.76665C11.0069 15.1667 12.127 15.1667 12.9826 14.7308C13.7353 14.3473 14.3472 13.7354 14.7307 12.9827C15.1666 12.1271 15.1666 11.007 15.1666 8.76675V8.23342C15.1666 5.9932 15.1666 4.8731 14.7307 4.01745C14.3472 3.2648 13.7353 2.65288 12.9826 2.26939C12.127 1.83341 11.0069 1.83341 8.76665 1.83341H8.23331C5.9931 1.83341 4.873 1.83341 4.01735 2.26939C3.2647 2.65288 2.65278 3.2648 2.26929 4.01745C1.83331 4.8731 1.83331 5.9932 1.83331 8.23341V8.76675C1.83331 11.007 1.83331 12.1271 2.26929 12.9827C2.65278 13.7354 3.2647 14.3473 4.01735 14.7308C4.873 15.1667 5.9931 15.1667 8.23331 15.1667Z",
    stroke: "#4D6EF5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1959_124066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScheduleNewActiveIcon);
export default ForwardRef;